import React, { useEffect } from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'

export const MenuDropdown = ({ blockId }: any) => {
  function getActiveNavItem () {
    const navItem = document.querySelector('.has-children')
    navItem?.addEventListener('mouseover', (e: any) => {
      if (e.target.parentElement.classList.contains('has-children')) {
        e.target.parentElement.classList.add('focus')
      }
      e.target.parentElement.classList.add('visited')
    })

    navItem?.addEventListener('mouseout', (e: any) => {
      if (e.target.classList.contains('focus')) {
        e.target.classList.remove('focus')
      }
    })
  }

  useEffect(() => {
    getActiveNavItem()
  })
  return (
    <>
      <CmsBlock
        id={blockId}
        isLazy
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            if (!process.env.REACT_APP_ENABLE_CMS_BLOCK_SAMPLE_DATA) {
              return null
            }

            return (
              <SampleData />
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
    </>
  )
}

const SampleData = () => {
  return (
    <>
      <ul className='children-level-1'>
        <li>
          <a href='/'>Bladder Control</a>
          <div>
            <ul className='children children-level-2'>
              <li>
                <a href='/'>All Types of Leakage</a>
              </li>
              <li>
                <a href='/'>
                  <i className='icon-drip' />
                  Drip
                </a>
                <div>
                  <ul className='children children-level-3'>
                    <li>
                      <a href='/'>Show Me Everything</a>
                    </li>
                    <li>
                      <a href='/'>Brand A</a>
                    </li>
                    <li>
                      <a href='/'>Brand B</a>
                    </li>
                    <li>
                      <a href='/'>Brand C</a>
                    </li>
                    <li>
                      <a href='/'>Brand D</a>
                    </li>
                    <li>
                      <a href='/'>Brand E</a>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <a href='/'>
                  <i className='icon-dribble' />
                  Dribble
                </a>
              </li>
              <li>
                <a href='/'>
                  <i className='icon-gush' />
                  Gush
                </a>
              </li>
              <li>
                <a href='/'>
                  <i className='icon-heavy-flow' />
                  Heavy Flow
                </a>
              </li>
              <li>
                <a href='/'>
                  <i className='icon-flooding' />
                  Flooding
                </a>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <a href='/'>Menopause</a>
        </li>
        <li>
          <a href='/'>Kegel</a>
        </li>
        <li>
          <a href='/'>Intimate Self-Care</a>
        </li>
        <li>
          <a href='/'>Health & Beauty</a>
        </li>
        <li>
          <a href='/'>Caregiving</a>
        </li>
      </ul>
    </>
  )
}
